{
    "LicenceManagementPage_Title": "Licentiebeheer",
    "LicenceManagementPage_Subtitle": "Beheer apparaat- en gebruikerstoewijzingen voor een geselecteerd telefoniebereik.",
    "LicenceManagementPage_Tile_Analytics": "CX-analyse",
    "LicenceManagementPage_Tile_Score": "CX-score",
    "LicenceManagementPage_Tile_Record": "CX-record",
    "LicenceManagementPage_Tile_Integration": "CX-integratie",
    "LicenceManagementPage_Tile_Licences": "Licenties",
    "LicenceManagementPage_Column_DeviceNumber": "Apparaat",
    "LicenceManagementPage_Column_Username": "Gebruikersnaam",
    "LicenceManagementPage_Column_Email": "E-mail",
    "LicenceManagementPage_Column_HasDevice": "Apparaat",
    "LicenceManagementPage_Column_Agent": "Tussenpersoon",
    "LicenceManagementPage_Column_WelcomeEmail": "Welkomstmail",
    "LicenceManagementPage_Column_Licences": "Licenties",
    "LicenceManagementPage_Column_Actions": "Acties",
    "LicenceManagementPage_Type_Device": "Apparaat",
    "LicenceManagementPage_Type_User": "Gebruiker",
    "LicenceManagementPage_Popup_TelSys": "Telefoonserver",
    "LicenceManagementPage_Popup_Partition": "Partitie",
    "LicenceManagementPage_Popup_Device": "Apparaat",
    "LicenceManagementPage_Popup_Username": "Gebruikersnaam",
    "LicenceManagementPage_Popup_Email": "E-mail",
    "LicenceManagementPage_Popup_Close": "Dichtbij",
    "LicenceManagementPage_LicencePopup_Title": "Productlicenties beheren",
    "LicenceManagementPage_LicencePopup_Licence": "Licentie",
    "LicenceManagementPage_LicencePopup_ScoreUserCalls": "Score gebruikersoproepen",
    "LicenceManagementPage_LicencePopup_RecordUserCalls": "Gebruikersgesprekken opnemen",
    "LicenceManagementPage_LicencePopup_IntegrationEnabled": "Ingeschakeld",
    "LicenceManagementPage_LicencePopup_On": "Op",
    "LicenceManagementPage_LicencePopup_Off": "Uit",
    "LicenceManagementPage_LicencePopup_Enabled": "Ingeschakeld",
    "LicenceManagementPage_LicencePopup_Disabled": "Gehandicapt",
    "LicenceManagementPage_LicencePopup_EmailRequired": "Voeg een e-mailadres toe voordat u de licentiewijzigingen voor dit apparaat opslaat.",
    "LicenceManagementPage_Email_AddTooltip": "Klik om een ​​e-mailadres toe te voegen en een gebruiker aan te maken.",
    "LicenceManagementPage_EssentialsExtension": "Essentiële zaken (uitbreiding)",
    "LicenceManagementPage_Empty": "Niets gevonden",
    "LicenceManagementPage_WelcomeEmail_Title": "Stuur de welkomstmail opnieuw naar \"{}\"",
    "LicenceManagementPage_WelcomeEmail_Confirm": "Wilt u de welkomstmail opnieuw verzenden naar \"{}\"?",
    "LicenceManagementPage_WelcomeEmail_Success": "De e-mail is succesvol verzonden naar \"{}\"",
    "LicenceManagementPage_WelcomeEmail_Fail": "Er is een onverwachte fout opgetreden tijdens het verzenden van de e-mail. Probeer het opnieuw.",
    "LicenceManagementPage_Licence_SaveFailed": "De huidige gebruikersinstellingen konden niet worden gelezen, waardoor de licenties niet zijn opgeslagen. Probeer het opnieuw.",
    "LicenceManagementPage_Column_LicencesCount": "[{} Licenties]",
    "LicenceManagementPage_Tick_Save": "Wijzigingen in de rij opslaan",
    "LicenceManagementPage_Tick_InvalidEmail": "Voer een geldig e-mailadres in om de gebruiker aan te maken.",
    "LicenceManagementPage_Licence_ScoringEnabled": "Scoren ingeschakeld",
    "LicenceManagementPage_Licence_RecordingEnabled": "Opname ingeschakeld",
    "LicenceManagementPage_Licence_WithScoring": "{} + Score",
    "LicenceManagementPage_Licence_WithRecording": "{} + Opname",
    "LicenceManagementPage_Username_NoUserTooltip": "Dit wordt gebruikt als gebruikersnaam bij het aanmaken van een nieuwe gebruiker.",
    "NAME": "LicentiebeheerPaginaTaal"
}